import { ISubHeaderType } from "../../../types/types";
import SubTitle from "../../subtitle/SubTitle";

type Props = {
  descText: string;
  textColor: string;
  style: {};
  cName?: string;
};

const SectionHeaderDesc = (props: Props) => {


  const subtitleStyle = {
    fontFamily: "Nunito",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "140%",
  };


  return (
    <div
      className="header-desc"
    >
      <SubTitle
        type={ISubHeaderType.h2}
        text={props.descText}
        textColor="#BABAC8"
        style={{ ...subtitleStyle, textAlign: "flex-start" }}
        cName="my-2"
        children=""
      />
    </div>
  );
};

export default SectionHeaderDesc;
